// extracted by mini-css-extract-plugin
export default {"fieldContainer":"ProductComponentOther_fieldContainer__x4rkZ"};